import { useNavigate } from 'react-router-dom';
import './LoginRequiredModal.css';

const LoginRequiredModal = ({ show, onClose, programName = "this program" }) => {
  const navigate = useNavigate();

  if (!show) return null;

  const handleGoToLogin = () => {
    onClose();
    navigate('/setting');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modern-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-icon">🔒</div>
          <h3>Login Required</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p>You must first login to {programName} before selecting it.</p>
        </div>
        <div className="modal-footer">
          <button className="modal-btn-primary" onClick={handleGoToLogin}>
            Go to Login
          </button>
          <button className="modal-btn-secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredModal;